import { PostHogProvider } from 'posthog-js/react';
import { PropsWithChildren } from 'react';
import posthog from './client';

const postHogKey = process.env.REACT_APP_POSTHOG_KEY;

const AnalyticsProvider = ({ children }: PropsWithChildren) => {
    if (!postHogKey) return <>{children}</>;

    return <PostHogProvider client={posthog}>
        {children}
    </PostHogProvider>;
};

export default AnalyticsProvider;
